import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import logoipsum2 from '../../assets/Images/logoipsum2.svg'
import logoipsum3 from '../../assets/Images/logoipsum3.svg'
import logoipsum4 from '../../assets/Images/logoipsum4.svg'
import logoipsum5 from '../../assets/Images/logoipsum5.svg'
import logoipsum6 from '../../assets/Images/logoipsum6.svg'

function Clients() {
    const settings = {
        // dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 0,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
    };
    return (
        <section className='logoipsum'>
            <div className="container d-flex flex-column text-center gap-4">
                <hr className='hr1' />
                <h3>Our Clients</h3>   {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300" */}
                <div className="companies">  {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300" */}
                    <Slider {...settings}>
                        <div>
                            <img src={logoipsum2} alt="logoipsum2.img" />
                        </div>
                        <div>
                            <img src={logoipsum3} alt="logoipsum3.img" />
                        </div>
                        <div>
                            <img src={logoipsum4} alt="logoipsum4.img" />
                        </div>
                        <div>
                            <img src={logoipsum5} alt="logoipsum5.img" />
                        </div>
                        <div>
                            <img src={logoipsum6} alt="logoipsum6.img" />
                        </div>
                    </Slider>
                </div>
                <hr className='hr2' />
            </div>

        </section>
    )
}

export default Clients
